<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    stroke-width="1.5"
    stroke="currentColor"
    viewBox="0 0 48.3 48.3"
    style="enable-background: new 0 0 48.3 48.3"
    xml:space="preserve"
    fill="currentColor"
    :class="{
      [`h-${height} w-${width}`]: true,
    }"
  >
    <g>
      <path
        class="st0"
        d="M46.9,22.8c-0.8,0-1.4,0.6-1.4,1.4v18.4c0,1.6-1.3,3-3,3H5.7c-1.6,0-3-1.3-3-3V5.7c0-1.6,1.3-3,3-3h18.4
		c0.8,0,1.4-0.6,1.4-1.4S24.9,0,24.1,0H5.7C2.6,0,0,2.6,0,5.7v36.9c0,3.1,2.6,5.7,5.7,5.7h36.9c3.1,0,5.7-2.6,5.7-5.7V24.1
		C48.3,23.4,47.7,22.8,46.9,22.8z"
      />
      <path
        class="st0"
        d="M33.5,0c-0.8,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4h10.2L23.2,23.2c-0.5,0.5-0.5,1.4,0,1.9c0.3,0.3,0.6,0.4,1,0.4
		s0.7-0.1,1-0.4L45.6,4.7v10.2c0,0.8,0.6,1.4,1.4,1.4c0.8,0,1.4-0.6,1.4-1.4V0H33.5z"
      />
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
    },
    height: {
      type: String,
    },
    width: {
      type: String,
    },
  },
};
</script>
<style scoped>
.st0 {
  fill: #d2001b;
}
</style>
